import PropTypes from "prop-types";
import React from "react";
import BaseComponent from "../../../../lib/components/BaseComponent";

import ButtonGroup from "../buttons/ButtonGroup";
import T from "../../../model/system/text_translations/Translator";
import Button from "../buttons/Button";
import {Backspace, Cached, Save, Tv} from "@mui/icons-material";

class VariablesButtonGroup extends BaseComponent {

  static REFRESH = 'REFRESH';
  static OVERWRITE = 'OVERWRITE';
  static SYNC = 'SYNC';
  static CANCEL = 'CANCEL';
  static SAVE = 'SAVE';
  static SHOW = 'SHOW';

  render() {
    let children = [];

    if (this.props.children) {
      React.Children.map(this.props.children, (child) => {
        children.push(child);
      });
    }

    let onClick = this.props.onClick;

    return <ButtonGroup className='mb-2'>
      <Button uid={VariablesButtonGroup.REFRESH} tooltip='Neuladen' onClick={onClick}><Cached/></Button>

      {!this.props.hideOverwriteButton && <Button uid={VariablesButtonGroup.OVERWRITE} onClick={onClick}>
        {T.action_overwrite()}</Button>}
      <Button uid={VariablesButtonGroup.SYNC} onClick={this.props.onClick}>
        {T.action_synchronize()}
      </Button>

      <Button uid={VariablesButtonGroup.CANCEL} tooltip={T.label_discard()} onClick={onClick}>
        <Backspace className='text-amber-500'/>
      </Button>

      <Button uid={VariablesButtonGroup.SAVE} tooltip={T.label_save()} onClick={onClick}><Save/></Button>

      <Button uid={VariablesButtonGroup.SHOW} tooltip='Vorschau' onClick={onClick}><Tv/></Button>

      {children}
    </ButtonGroup>;
  }
}

VariablesButtonGroup.propTypes = {
  onClick: PropTypes.func, hideOverwriteButton: PropTypes.bool
}

export default VariablesButtonGroup;